import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthService } from '../../features/login/auth.service';
import { canAccessMockModule, RouteAccessKey } from './mock-rbac';

export function canMatchByModule(key: RouteAccessKey): CanMatchFn {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const user = authService.currentUser();

    if (!user) {
      return router.createUrlTree(['/login']);
    }

    if (!canAccessMockModule(user.role, key)) {
      return router.createUrlTree(['/dashboard']);
    }

    return true;
  };
}
